import React from "react";
import Helmet from "react-helmet";
import { basename } from "path";
import graphql from "graphql";
import config from "../../config/siteConfig";
import SEO from "../components/seo/seo-component";

import FadeIn from "../components/fade-in";
import PageWrapper from "../components/page-wrapper/page-wrapper.jsx";
import PageHeader from "../components/page-header/page-header.jsx";
import Section from "../components/page-section/page-section.jsx";
import ContactForm from "../components/contact-form/contact-form.jsx";
import Press from "../components/press/press.jsx";

// find page title by path
const findNode = (path, data) =>
  data.allMarkdownRemark.edges
    .map(edge => edge.node.frontmatter)
    .filter(r => r.path === path)
    .pop();

class Template extends React.Component {
  componentDidMount() {
    this.props.history.push("/");
  }
  render() {
    const { markdownRemark: page } = this.props.data;
    const path = this.props.data.markdownRemark.frontmatter.path;
    const pageNode = this.props.data.markdownRemark;
    return (
      <PageWrapper>
        <Helmet title={`${page.frontmatter.title} | ${config.siteTitle}`} />
        <SEO pagePath={path} pageNode={pageNode} pageSEO />
        <PageHeader
          title={page.frontmatter.titleLong}
          subtitle={page.frontmatter.description}
          cta={page.frontmatter.cta}
          ctaLink={page.frontmatter.ctaLink}
          backgroundImage={
            page.frontmatter.coverImage.childImageSharp.resolutions.src
          }
        />
        <FadeIn>
          <Section className="my-5">{/* <ContactForm /> */}</Section>
          <Section title="Press" className="bg-white pt-3 pb-3">
            <Press data={this.props.data.press.edges} />{" "}
          </Section>
        </FadeIn>
      </PageWrapper>
    );
  }
}

export default Template;

export const pageQuery = graphql`
  query ThanksByPage($path: String!) {
    markdownRemark(frontmatter: { path: { eq: $path } }) {
      html
      frontmatter {
        path
        date(formatString: "MMMM DD, YYYY")
        title
        titleLong
        description
        cta
        ctaLink
        coverImage {
          childImageSharp {
            resize(width: 800) {
              src
            }
            resolutions(width: 1200) {
              width
              height
              src
              srcSet
            }
          }
        }
      }
    }
    press: allPressJson {
      edges {
        node {
          ...Press_list
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/thanks.js